import React, { MouseEvent, ReactElement, ReactNode, useState } from 'react';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { Box, IconButton, Menu } from '@material-ui/core';
import { LinkButton } from '../../atoms';
import { useTranslation } from 'react-i18next';

export interface IContextMenuButtonProps {
	linkButton?: boolean;
	id?: string;
	icon?: ReactElement;
	children?: ReactNode;
	className?: string;
	closeOnSelect?: boolean | undefined;
	size?: 'medium' | 'small';
	anchorOrigin?: {
		vertical: 'top' | 'center' | 'bottom';
		horizontal: 'left' | 'center' | 'right';
	};
	transformOrigin?: {
		vertical: 'top' | 'center' | 'bottom';
		horizontal: 'left' | 'center' | 'right';
	};
}

export function ContextMenuButton(
	props: IContextMenuButtonProps
): ReactElement {
	const {
		linkButton,
		id,
		icon,
		className,
		children,
		closeOnSelect,
		size,
		anchorOrigin,
		transformOrigin
	} = props;
	const { t } = useTranslation('general');

	const [anchor, setAnchor] = useState<HTMLElement>();
	const [open, setOpen] = useState<boolean>(false);

	function handleClick(event: MouseEvent<HTMLButtonElement>): void {
		event.stopPropagation();
		setAnchor(event.currentTarget);
		setOpen(!open);
	}

	function handleMenuClick(event: MouseEvent<HTMLElement>): void {
		event.stopPropagation();
		if (closeOnSelect) {
			handleClose();
			setOpen(false);
		}
	}

	function handleClose(): void {
		setAnchor(undefined);
	}

	return linkButton ? (
		<LinkButton
			onClick={(e) => handleClick(e!)}
			className={`${className} ${open ? 'open' : ''}`}
		>
			<MoreVertIcon />
			<Menu
				open={Boolean(anchor)}
				anchorEl={anchor}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'center'
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left'
				}}
				getContentAnchorEl={null}
				onClick={handleMenuClick}
				onClose={handleClose}
			>
				{children}
			</Menu>
			{t('optionsButton.moreOptions')}
		</LinkButton>
	) : (
		<Box>
			<IconButton
				className={`${className} ${open ? 'open' : ''}`}
				onClick={handleClick}
				size={size}
			>
				{icon ? icon : <MoreVertIcon />}
			</IconButton>
			<Menu
				id={id}
				open={Boolean(anchor)}
				onClick={handleMenuClick}
				onClose={handleClose}
				anchorEl={anchor}
				anchorOrigin={anchorOrigin}
				transformOrigin={transformOrigin}
				getContentAnchorEl={null}
			>
				{children}
			</Menu>
		</Box>
	);
}
